import { NgModule } from "@angular/core";
import {SearchComponent} from "@app/components/search/search.components";
import {PageTitleModule} from "@app/components/page-title/page-title.module";
import {MedBtnModule, MedBubbleModule, MedCardModule, MedPaginationModule, MedRadioGroupModule} from "@mk/med-ui";
import {JsonPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {ErrorModule} from "@app/components/error/error.module";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {MedIconCarModule, MedIconHospitalBuildingModule, MedIconTransactionModule} from "@mk/med-icons";
import {LoaderModule} from "@app/components/loader/loader.module";
import {DockModule} from "primeng/dock";
import {VirtualScrollerModule} from "primeng/virtualscroller";

@NgModule({
  declarations: [
    SearchComponent
  ],
  imports: [
    PageTitleModule,
    MedCardModule,
    NgForOf,
    MedBubbleModule,
    JsonPipe,
    MedPaginationModule,
    MedRadioGroupModule,
    ErrorModule,
    NgIf,
    ScrollPanelModule,
    MedIconCarModule,
    NgClass,
    MedIconTransactionModule,
    MedIconHospitalBuildingModule,
    LoaderModule,
    DockModule,
    VirtualScrollerModule,
    MedBtnModule,
  ],
  exports: [

  ],
})
export class SearchModule { }
